import script from "./single-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-select.vue?vue&type=script&setup=true&lang=ts"

import "./single-select.vue?vue&type=style&index=0&id=f59ffbea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f59ffbea"]])

export default __exports__